import { render, staticRenderFns } from "./RegisterKO.vue?vue&type=template&id=0d9da452&"
import script from "./RegisterKO.vue?vue&type=script&lang=js&"
export * from "./RegisterKO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports